'use client';

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';
import { DesktopSideAdBanner } from '@/app/_components/ads';
import { DesktopPageShell } from '@/components/template/DesktopPageShell';
import { useAppBack } from '@/modules/wello-app/_hooks/useAppBack';
import { useAuthStore } from '@/stores/AuthStore';
import { ChatbotFlow } from './_components/ChatbotFlow';
import { Header } from './_components/Header';
import { PolicyContent } from './_components/PolicyContent';
import { PolicyContentSkeleton } from './_components/PolicyContentSkeleton';
import { PolicyFilter } from './_components/PolicyFilter';
import { PolicyListErrorBoundary } from './_components/PolicyListErrorBoundary';
import { StatisticsCard } from './_components/StatisticsCard';
import { StatisticsCardSkeleton } from './_components/StatisticsCardSkeleton';
import { StatisticsErrorBoundary } from './_components/StatisticsErrorBoundary';
import type { FilterType, SortType, ViewMode } from './_types/types';
const RecommendPolicyPage = () => {
  const $ = _c(28);
  useAppBack();
  const searchParams = useSearchParams();
  const myInfo = useAuthStore(_temp);
  const isLoggedIn = !!myInfo;
  if (!isLoggedIn) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="flex flex-1 flex-col bg-Gray-50"><DesktopPageShell><ChatbotFlow /></DesktopPageShell></div>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== searchParams) {
    t0 = searchParams.get("sort") as SortType ?? "PRIORITY";
    $[1] = searchParams;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const sort = t0;
  let t1;
  if ($[3] !== searchParams) {
    t1 = searchParams.get("filter");
    $[3] = searchParams;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const filter = t1 as FilterType | undefined;
  let t2;
  if ($[5] !== searchParams) {
    t2 = searchParams.get("viewMode") as ViewMode ?? "timeline";
    $[5] = searchParams;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const viewMode = t2;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DesktopSideAdBanner />;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      background: "linear-gradient(to bottom, rgb(221, 242, 255) 0px, rgb(249, 249, 249) 400px, rgb(249, 249, 249))"
    };
    t5 = <h1 className="sr-only">맞춤 정책 추천</h1>;
    t6 = <Header />;
    t7 = <PolicyFilter />;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <StatisticsCardSkeleton />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== sort) {
    t9 = <StatisticsErrorBoundary><Suspense fallback={t8}><StatisticsCard sort={sort} /></Suspense></StatisticsErrorBoundary>;
    $[13] = sort;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== viewMode) {
    t10 = <PolicyContentSkeleton viewMode={viewMode} />;
    $[15] = viewMode;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== filter || $[18] !== sort || $[19] !== viewMode) {
    t11 = <PolicyContent sort={sort} filter={filter} viewMode={viewMode} />;
    $[17] = filter;
    $[18] = sort;
    $[19] = viewMode;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11 || $[23] !== viewMode) {
    t12 = <PolicyListErrorBoundary><Suspense key={viewMode} fallback={t10}>{t11}</Suspense></PolicyListErrorBoundary>;
    $[21] = t10;
    $[22] = t11;
    $[23] = viewMode;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t9) {
    t13 = <DesktopPageShell className="pt-40 mobile-tablet:pt-0" mainClassName="flex flex-col" rightAside={t3}><div className="flex w-full flex-col" style={t4}>{t5}{t6}{t7}{t9}{t12}</div></DesktopPageShell>;
    $[25] = t12;
    $[26] = t9;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
};
export default RecommendPolicyPage;
function _temp(state) {
  return state.myInfo;
}